import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="bg-canvas" data-id="element-41" data-mp="1hd1p22n39g1m">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" style={{
      paddingTop: "18px",
      paddingBottom: "15px"
    }} data-id="element-42" data-mp="1hb8fofl3chpx">
        <h2 id="faq-title" className="text-center font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-43" data-mp="2a28nz2qgg7ne">
          Frequently asked questions
        </h2>
        <div className="mt-10 divide-y divide-line overflow-hidden rounded-2xl border border-line bg-white" data-id="element-44" data-mp="253owynx085o6">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-45" data-mp="1v3y40qo3dyq7" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-canvas focus:outline-none focus-visible:bg-canvas" data-id="element-46" data-mp="1v4q0s4tfe2i2">
                  <span className="text-[15px] font-semibold text-ink sm:text-base" data-id="element-47" data-mp="1ko9qi5wwmq2q">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold-ink" data-id="element-48" data-mp="1pmbaqu62gvfs" /> : <PlusIcon className="h-5 w-5 shrink-0 text-muted" data-id="element-49" data-mp="1aq2e80dk8w72" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-200 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-50" data-mp="1fo44b59elvs1">
                  <div className="overflow-hidden" data-id="element-51" data-mp="11ve6m3kij2f3">
                    <div className="space-y-2 px-6 pb-5" data-id="element-52" data-mp="16p0kfz2excch">
                      {f.a.map(p => <p key={p} className="text-sm leading-relaxed text-muted" data-id="element-53" data-mp="rzb2wta0ivq1">
                          {p}
                        </p>)}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}